<doka-modal-wrapper (close)="closeModal()">
  <ng-template #title>
    {{ "MasterData.Currencies.AssignTitle" | i18nextEager }}: {{ currency().isoCurrencyCode }}
  </ng-template>
  <ng-template #content>
    <div class="flex flex-col gap-md">
      @for (country of countries(); track country.id) {
        <doka-checkbox
          [checked]="isSelected(country.id)"
          [disabled]="isMainCurrency(country)"
          (checkedChange)="toggleCountry(country, $event)"
          [label]="countryLabel(country)"
          [attr.data-testid]="'edit-currency-countries-checkbox-' + country.id"
        />
      }
    </div>
  </ng-template>
  <ng-template #footer>
    <div class="flex w-full gap-md px-6 pt-4 items-center justify-end">
      <doka-button
        [disabled]="isLoading()"
        (click)="closeModal()"
        color="secondary"
        data-testid="edit-currency-countries-cancel-button"
      >
        {{ "Common.Cancel" | i18nextEager }}
      </doka-button>
      <doka-button
        [disabled]="isLoading()"
        (click)="submit()"
        color="primary"
        data-testid="edit-currency-countries-save-button"
      >
        {{ "Common.Save" | i18nextEager }}
      </doka-button>
    </div>
  </ng-template>
</doka-modal-wrapper>
